const IS_SHARED_WORKER_SUPPORTED = typeof(SharedWorker) !== 'undefined'/*  && false */;

export default IS_SHARED_WORKER_SUPPORTED;
